import React, { Component } from 'react';
import {resolveVariables} from 'functions';
import {Div} from 'library';

class ContainerFluid extends React.Component {
    static component_name = 'ContainerFluid';
          render() {

                return (
                    <Div className="container-fluid" style={this.props.style}>
                      {this.props.children}
                    </Div>
                );
            }
}


export default ContainerFluid;
